export default "__VITE_ASSET__CA7lh8JJ__"